import { Injectable } from '@angular/core';
import { CatalogObject, LineItem, ShopLineItemMap } from '../models/payment-item.model';
import { MenuItemForPayment } from '../models/cart-item.model';
import { Price } from '../models/restaurant.model';

@Injectable()
export class ConvertItemsService {
  public static fromCartItemsToShopLineItems(cartItems: MenuItemForPayment[]): ShopLineItemMap {
    const shopLineItems: ShopLineItemMap = {};

    cartItems.forEach((cartItem) => {
      let amount = 0;

      if (!shopLineItems[cartItem.locationId]) {
        shopLineItems[cartItem.locationId] = {
          amount: 0,
          line_items: [],
          discounts: [],
          metadata: {}
        };
      }

      const variation = [new CatalogObject(cartItem.item.variation.id, cartItem.categoryId)];
      amount += cartItem.item.variation.price_money.amount;

      const modifiersCatalogObject = cartItem.item.modifiers.map((modifier) => {
        const modifierQuantity = Number(modifier.quantity || 1);
        const modifierAmount = Number(modifier.price_money?.amount || 0) * modifierQuantity;

        amount += modifierAmount;

        if (
          modifier.name.includes('{Light}') ||
          modifier.name.includes('{Regular}') ||
          modifier.name.includes('{Extra}')
        ) {
          const adHocName = modifier.name
            .replace('{Light}', '(Light)')
            .replace('{Regular}', '(Regular)')
            .replace('{Extra}', '(Extra)');

          return new CatalogObject(
            null,
            cartItem.category_id,
            adHocName,
            new Price(modifier.price_money.amount, modifier.price_money.currency),
            modifier.on_by_default,
            modifier.hidden_online,
            modifier.selected,
            String(modifierQuantity)
          );
        }

        return new CatalogObject(
          modifier.id,
          modifier.id,
          modifier.name,
          modifier.price_money,
          modifier.on_by_default,
          modifier.hidden_online,
          modifier.selected,
          String(modifierQuantity)
        );
      });

      const lineItem = new LineItem(
        cartItem.item.quantity,
        cartItem.item.id,
        cartItem.item.category_id,
        variation,
        modifiersCatalogObject,
        cartItem.item.specialInstructions
      );

      lineItem.metadata = cartItem?.metadata;

      shopLineItems[cartItem.locationId].amount += Math.ceil(amount) * cartItem.item.quantity;
      shopLineItems[cartItem.locationId].line_items.push(lineItem);
    });

    return shopLineItems;
  }
}
